import * as ko from 'knockout'
import { IObservableFinisher } from '@classic/Betting-v2/Model/Observables/IObservableFinisher'
import template from './finisher.place.tpl.html'
import { FinisherPlaceViewModel } from './FinisherPlaceViewModel'

if (!ko.components.isRegistered('finisher-place')) {
  ko.components.register('finisher-place', {
    viewModel: {
      createViewModel: (params: { finisher: IObservableFinisher }) => {
        const viewModel = new FinisherPlaceViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
